module.exports = __webpack_public_path__ + "img/result-hit-stamp.79ec79b6.svg";